import React, { useEffect, useRef, useState } from 'react';
import classes from './styles.module.scss';
import { IonRippleEffect, IonIcon, IonButton, IonChip } from '@ionic/react';
import { closeSharp } from 'ionicons/icons';
import InputCard from '../inputField';
import { IoAdd, IoClose, IoPricetag } from 'react-icons/io5';
import { LuTag } from 'react-icons/lu';
import { addSingleTag, getAllTags } from '../../context/actions/tags';
import useGlobalContext from '../../hooks/useStore';
import ErrorToast from '../error_toast';
import Spinner from '../spinner';
import { similarity } from '../../utils/strings';

const AddTag = ({
  name,
  listedTags,
  setTags,
}: {
  name: string;
  listedTags: any[];
  setTags: (arg0: (form: any) => any) => any;
}) => {
  const { tagsDispatch, tagState } = useGlobalContext();
  const [savedTags, setSavedTags] = useState<any[]>([]);
  const [tag, setTag] = useState<{ name: string }>({ name: '' });
  const [suggestedTags, setSuggestedTags] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const dropDownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    fetchTags();
  }, []);
  useEffect(() => {
    setSuggestedTags(savedTags.slice(0, 10));
  }, [savedTags]);
  useEffect(() => {
    if (open) {
      let elem = dropDownRef.current!;
      elem?.scrollIntoView();
    }
  }, [open]);
  useEffect(() => {
    if (tag?.name) {
      setOpen(true);
      handleFiltering();
    } else {
      // setOpen(false);
      if (savedTags) setSuggestedTags(savedTags.slice(0, 10));
    }
  }, [tag?.name]);

  useEffect(() => {
    if (tagState.tags?.length) {
      setSavedTags(tagState.tags);
    }
  }, [tagState.tags?.length]);

  const handleEnter = async () => {
    await handleSaveTag();
  };
  const fetchTags = async () => {
    const res = await getAllTags()(tagsDispatch)!;
    if (res?.error) {
      setError(res.message);
      // setOpenError(true);
    }
  };
  const handleSaveTag = async () => {
    setLoading(true);
    handleAddTag(tag.name);
    if (savedTags.some((i) => i.name === tag.name)) return;
    const res = await addSingleTag(tag)(tagsDispatch);
    if (res?.error) {
      setError(res.message);
      setOpenError(true);
      setLoading(false);
      return;
    }
  };
  const handleAddTag = (_name: string) => {
    setTags((prev) => {
      let tags = prev[name] || [];
      tags?.push(_name);
      return {
        ...prev,
        [name]: tags,
      };
    });
    setTag({ name: '' });
    setLoading(false);
    setOpen(false);
  };
  const handleFiltering = () => {
    const tags = savedTags
      .filter((item) => {
        let score = similarity(item.name, tag.name);
        let includes = item.name.includes(tag.name);
        let listed = listedTags.includes(item.name);
        return score > 0.1 && !listed && includes;
      })
      .sort((a, b) => b.score - a.score);

    setSuggestedTags(tags);
  };
  return (
    <div className="size-full relative flex flex-col">
      <ErrorToast
        isOpen={openError}
        message={error}
        onClose={() => {
          setOpenError(false);
        }}
        type="error"
        position="bottom"
      />
      <div className="w-full h-auto flex items-center">
        <InputCard
          inputType="text-field"
          name="name"
          placeholder="Add Tag"
          value={setTag}
          type="text"
          formValues={tag}
          borders
          clear
          enterEvent={handleEnter}
          icon={<LuTag size="20" />}
          icon-slot="start"
          onFocus={() => {
            setOpen(true);
          }}
        />
      </div>
      {open && (
        <div
          className='before:fixed before:top-0 before:right-0 before:bottom-0 before:left-0 before:bg-transparent before:z-10 before:content-[""] before:block before:col-[1/1]'
          onClick={() => {
            setOpen(false);
          }}
        >
          <div
            className="w-full h-auto min-h-[150px] bg-white absolute top-14 shadow-2xl border z-20 p-2 flex flex-col "
            ref={dropDownRef}
          >
            {!loading && (
              <>
                <div className="w-full h-auto flex mb-2 border-b items-center px-2 py-1">
                  <span className="w-full h-auto text-primary font-normal text-lg">
                    {tag.name}
                  </span>
                  <button
                    onClick={handleSaveTag}
                    className="size-[40px] !m-0 hover:bg-background rounded-lg p-[10px]"
                  >
                    <IoAdd size="100%" />
                  </button>
                </div>
                <div className="w-full h-auto flex-1 flex gap-1 flex-wrap">
                  {suggestedTags.map((item) => {
                    return (
                      <IonChip
                        className="m-0"
                        color="primary"
                        key={item.id}
                        onClick={() => {
                          handleAddTag(item.name);
                        }}
                      >
                        {item.name}
                      </IonChip>
                    );
                  })}
                </div>
              </>
            )}
            {loading && (
              <div className="w-full h-auto flex-1 flex items-center justify-center ">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AddTag;
